import { useQuery } from '@apollo/client';

import type {
  GetCourseByIdQuery,
  GetCourseByIdQueryVariables,
} from 'bundles/expression-of-interest/queries/__generated__/getCourseById';
import getCourseById from 'bundles/expression-of-interest/queries/getCourseById.graphql';

export const useGetCourseById = (courseId?: string) => {
  const { loading, data } = useQuery<GetCourseByIdQuery, GetCourseByIdQueryVariables>(getCourseById, {
    skip: !courseId,
    variables: { id: `${courseId}` },
    context: { clientName: 'gatewayGql' },
  });

  return { loading, course: data?.Course?.queryById };
};
